import React from 'react'

import CTA from '@f/elements/CTA'

const SearchResultsPagination = props => {
  const handleClick = ({ event, direction = '', forcedPage = '' }) => {
    event.preventDefault()

    let params = { ...props.params }
    let page = parseInt(props.page)

    if (direction === 'next') {
      params['page'] = page + 1
    } else if (direction === 'previous') {
      params['page'] = page !== 1 ? page - 1 : ''
    }

    if (forcedPage !== '') {
      params['page'] = forcedPage
    }

    if (params['page'] === '' || params['page'] == 1) {
      delete params['page']
    }

    const isExLeadsVariant = props.variant === 'ex_leads'

    if (isExLeadsVariant) {
      const EXLeadsHouseSearch = document.querySelector('.SearchResultsFilters')
      const scrollPosition = EXLeadsHouseSearch.getBoundingClientRect().top
      document.body.scrollTop = document.documentElement.scrollTop =
        window.scrollY + scrollPosition
    } else {
      document.body.scrollTop = document.documentElement.scrollTop = 0
    }

    props.updateParams(params, { isPagination: true })
  }

  let page = parseInt(props.page)
  let pageCount = Math.ceil(props.totalCount / props.resultCount)
  let pageString = `${page}/${pageCount}`

  let pages = []
  let startPaginationAt = page < 6 ? 1 : page - 1
  let endPaginationAt = page < 3 ? 4 : page + 2

  // If page count is exactly 2 there is no chance for a surrounding pagination
  // It's the one and only time we need to calc for ceil
  if (pageCount === 2) {
    endPaginationAt = 2
    pageCount = 2
  } else if (pageCount < 2) {
    return null
  }

  if (startPaginationAt !== 1) {
    pages.push(
      <li
        onClick={event => handleClick({ event, forcedPage: '1' })}
        key='pagination-1'
        className='[ f-d-inbl f-p-a-010 f-m-a-005 f-t-body ]'>
        1
      </li>
    )
    pages.push(
      <li
        onClick={event => handleClick({ event, forcedPage: '2' })}
        key='pagination-2'
        className='[ f-d-inbl f-p-a-010 f-m-a-005 f-t-body ]'>
        2
      </li>
    )

    if (page + 2 === pageCount) {
      pages.push(
        <li
          onClick={event => handleClick({ event, forcedPage: '3' })}
          key='pagination-3'
          className='[ f-d-inbl f-p-a-010 f-m-a-005 f-t-body ]'>
          3
        </li>
      )
    }

    pages.push(
      <li
        className='[ f-d-inbl f-p-a-010 f-m-a-005 f-t-body ]'
        key='pagination-more-left'>
        ...
      </li>
    )
  }

  for (startPaginationAt; startPaginationAt <= pageCount; startPaginationAt++) {
    let uniqueKey = `pagination-${startPaginationAt}`
    let pageLink = `${startPaginationAt}`

    if (startPaginationAt === endPaginationAt) {
      if (startPaginationAt === page) {
        pages.push(
          <li
            key={uniqueKey}
            className='[ f-d-inbl f-p-a-010 f-m-a-005 f-t-body f-c-fo-neu400 ]'>
            {startPaginationAt}
          </li>
        )
      } else if (endPaginationAt === pageCount) {
        pages.push(
          <li
            className='[ f-d-inbl f-p-a-010 f-m-a-005 f-t-body ]'
            key={uniqueKey}>
            <CTA
              className='[ f-t-body f-c-fo-neu400 ]'
              type='text-primary'
              onClick={event => handleClick({ event, forcedPage: pageLink })}>
              {startPaginationAt}
            </CTA>
          </li>
        )
      } else {
        pages.push(
          <li
            className='[ f-d-inbl f-p-a-010 f-m-a-005 f-t-body f-c-fo-neu400 ]'
            key='pagination-more-right'>
            ...
          </li>
        )
      }
    } else if (startPaginationAt === page) {
      pages.push(
        <li
          key={uniqueKey}
          className='[ f-d-inbl f-p-a-010 f-m-a-005 f-t-body f-c-fo-neu400 ]'>
          {startPaginationAt}
        </li>
      )
    } else {
      if (
        !(startPaginationAt > endPaginationAt && startPaginationAt < pageCount)
      ) {
        pages.push(
          <li
            className='[ f-d-inbl f-p-a-010 f-m-a-005 f-t-body ]'
            key={uniqueKey}>
            <CTA
              type='text-primary'
              className='[ f-t-body f-c-fo-neu400 ]'
              onClick={event => handleClick({ event, forcedPage: pageLink })}>
              {startPaginationAt}
            </CTA>
          </li>
        )
      }
    }
  }

  return (
    <aside className='[ f-p-v-030 ]'>
      <nav className='[ f-d-flr ]'>
        {props.params.page && props.params.page != 1 && (
          <div>
            <CTA
              type='block-secondary'
              className='[ f-p-h-020 ]'
              style={{ minWidth: 0 }}
              onClick={event => handleClick({ event, direction: 'previous' })}>
              Vorherige Seite
            </CTA>
          </div>
        )}

        <ul className='[ f-!list f-hidden:s f-t-centre f-fl-expand ]'>
          {pages}
        </ul>
        <span className='[ f-hidden:m f-hidden:l f-t-body f-c-fo-neu400 f-p-v-020 f-p-h-030 ]'>
          {pageString}
        </span>

        {props.params.page != pageCount && (
          <div>
            <CTA
              type='block-secondary'
              className='[ f-p-h-020 ]'
              style={{ minWidth: 0 }}
              onClick={event => handleClick({ event, direction: 'next' })}>
              Nächste Seite
            </CTA>
          </div>
        )}
      </nav>
    </aside>
  )
}

export default SearchResultsPagination
